import React, { useState } from 'react';
import '../../../styles/homepagecss/FabricThreadContainer.css';


const HomeFabrics = () => {
  const [hoveredTool, setHoveredTool] = useState(null);

  const tools1 = [
    { id: 'iam', name: 'Identity Access Management Console', description: 'IAM Console enables admins to orchestrate user access through permission sets, ensuring secure, role-based control across every fabric and AI workflow.' },
  ];

  const tools2 = [
    { id: 'rag', name: 'Advanced RAG Data Pipeline', description: 'Retrieval-Augmented Generation preprocessing that intelligently structures your unstructured data for AI processing' },
    { id: 'analytics', name: 'Structured Data Analytics', description: 'Python-based AI analytics for deep insights from structured data without RAG processing' }
  ];

  return (
    <section className="background-color1">
      <div className="container margin-top-5">
        <div className="row g-5">
          <div className="col-lg-6 col-md-6 col-12"> 
            <p className="ev-reg-p-blue ev-fs-50 mb-1"><i className="bi bi-boxes"></i></p>
            <p className="ev-reg-p-dark ev-fs-35 ev-light-reg mb-2">Enterprise AI Project Marketplace</p>  
            <p className="ev-reg-p-dark ev-fs-15 ev-reg margin-bottom-5">Orchestrate workflows in a <span className="ev-reg-p-blue ev-fs-15 ev-bold-reg">Unified Governed Ecosystem</span>. Evaior's Project Marketplace enables secure collaboration, empowering teams to share insights while maintaining secured control.</p>  
            
            {/* Processing Tools */}
            <div>
              {tools1.map(tool => (
                <div key={tool.id} className="">
                  <button
                    className="tool-card-hover d-inline"
                    onMouseEnter={() => setHoveredTool(tool.id)}
                    onMouseLeave={() => setHoveredTool(null)}
                  >
                    <div className="d-flex align-items-center">
                      <div className=" ev-bold-reg ev-fs-20 me-2">
                        <i className="bi bi-plus-circle-dotted"></i>
                      </div>
                      <h4 className=" ev-bold-reg ev-fs-14 mb-0">{tool.name} &nbsp;</h4>
                    </div>
                  </button>
                  <div className={`tool-description ${hoveredTool === tool.id ? 'show' : ''}`}>
                    <p className="ev-reg-p-dark mb-0 ms-1">{tool.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12"> 
            <p className="ev-reg-p-blue ev-fs-50 mb-1"><i className="bi bi-boxes"></i></p>
            <p className="ev-reg-p-dark ev-fs-35 ev-light-reg mb-2">Data Collections</p>  
            <p className="gradient-font6 ev-fs-35 ev-bold-med mb-2">Reusable Data Intelligence.</p> 
            <p className="ev-reg-p-dark ev-fs-15 ev-reg margin-bottom-5">Upload your data once, use them everywhere. Update in one place, reflect across all Projects. Simplicity by design. For example, Group all safety reports in one Data Collection.</p>  
            
            {/* Processing Tools */}
            <div className="row g-4 margin-bottom-15">
              {tools2.map(tool => (
                <div key={tool.id} className="col-6">
                  <button
                    className="tool-card-hover"
                    onMouseEnter={() => setHoveredTool(tool.id)}
                    onMouseLeave={() => setHoveredTool(null)}
                  >
                    <div className="d-flex align-items-center">
                      <div className=" ev-bold-reg ev-fs-20 me-2">
                        <i className="bi bi-plus-circle-dotted"></i>
                      </div>
                      <h4 className=" ev-bold-reg ev-fs-14 mb-0">{tool.name}&nbsp;&nbsp;</h4>
                    </div>
                  </button>
                  <div className={`tool-description ${hoveredTool === tool.id ? 'show' : ''}`}>
                    <p className="ev-reg-p-dark mb-0 ms-1">{tool.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFabrics;